import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";
import { PriceBlock, StockBadge } from "./ProductBits";
import { ProductActions } from "./ProductActions";

export const FeaturedProduct = ({ product: p }) => (
  <article className="grid items-center gap-10 rounded-[2rem] bg-white p-5 shadow-[0_40px_80px_-50px_rgba(1,78,150,0.45)] ring-1 ring-slate-200/80 sm:p-8 lg:grid-cols-2 lg:gap-16 lg:p-12" data-testid={`featured-product-${p.slug}`}>
    <Link to={`/shop/${p.slug}`} className="block overflow-hidden rounded-3xl bg-gradient-to-br from-brand-greenTint via-white to-brand-skyTint" aria-label={`View ${p.name}`}>
      <img src={imgUrl(p.images?.[0]?.url)} alt={p.images?.[0]?.alt || p.name} width="1600" height="1600" className="aspect-square w-full object-cover transition-transform duration-500 hover:scale-[1.02]" />
    </Link>
    <div>
      <p className="eyebrow">{p.category}</p>
      <h2 className="font-heading text-3xl font-extrabold tracking-tight text-brand-ink sm:text-4xl">
        <Link to={`/shop/${p.slug}`} className="hover:text-brand-blue" data-testid="featured-product-link">{p.name}</Link>
      </h2>
      <p className="mt-2 text-lg text-slate-700">{p.subtitle}</p>
      <p className="mt-1 text-sm text-slate-600">{p.product_type} · {p.pack_size}</p>
      <div className="mt-6"><PriceBlock product={p} /></div>
      <div className="mt-4"><StockBadge product={p} /></div>
      <div className="mt-6"><ProductActions product={p} testid="featured" /></div>
      <Link to={`/shop/${p.slug}`} className="text-link mt-6" data-testid="featured-details-link">View composition, usage and full details →</Link>
    </div>
  </article>
);

export const ProductCard = ({ product: p }) => (
  <article className="flex flex-col overflow-hidden rounded-3xl bg-white ring-1 ring-slate-200/80 transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_28px_56px_-28px_rgba(83,147,35,0.5)]" data-testid={`product-card-${p.slug}`}>
    <Link to={`/shop/${p.slug}`} className="relative block bg-gradient-to-br from-brand-greenTint via-white to-brand-skyTint">
      <img src={imgUrl(p.images?.[0]?.thumb || p.images?.[0]?.url)} alt={p.images?.[0]?.alt || p.name} loading="lazy" className="aspect-square w-full object-cover" />
      {p.on_sale && <span className="absolute left-3 top-3 rounded-full bg-red-700 px-2.5 py-0.5 text-xs font-bold uppercase text-white">Sale</span>}
    </Link>
    <div className="flex flex-1 flex-col gap-3 p-5">
      <h2 className="text-lg font-bold text-brand-ink"><Link to={`/shop/${p.slug}`} className="hover:text-brand-blue">{p.name}</Link></h2>
      <p className="text-sm text-slate-600">{p.subtitle}</p>
      <PriceBlock product={p} size="sm" />
      <StockBadge product={p} />
    </div>
  </article>
);
